import { createContext } from 'react'

import { TaskCompletedDetail } from 'packages/sdks-next/growp'
import { AnyType } from 'packages/types'

import { TreeOutline } from './types'

export const CourseContext = createContext<{
  currentOutline?: TreeOutline
  setCurrentOutline?: (val: TreeOutline | undefined) => void
  taskId: number
  activityId: number
  isPreview: boolean
  completedDetails?: TaskCompletedDetail[]
}>(null as AnyType)
